import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "../../services/api";

export default function AdminTrash() {
  const navigate = useNavigate();
  const [users, setUsers]           = useState([]);
  const [loading, setLoading]       = useState(true);
  const [search, setSearch]         = useState("");
  const [roleFilter, setRoleFilter] = useState("all");
  const [restoringId, setRestoringId] = useState(null);
  const [deletingId, setDeletingId]   = useState(null);
  const [confirmId, setConfirmId]     = useState(null);
  const [sidebarOpen, setSidebarOpen] = useState(false);

  const navItems = [
    { label:"Dashboard", emoji:"🏠", path:"/admin/dashboard" },
    { label:"Users",     emoji:"👥", path:"/admin/users" },
    { label:"Trash",     emoji:"🗑️", path:"/admin/trash", active:true },
  ];

  const fetchTrashed = async () => {
    setLoading(true);
    try {
      const res = await api.get("/admin/trash");
      setUsers(res.data.users || []);
    } catch (e) { console.error(e); }
    finally { setLoading(false); }
  };

  useEffect(() => { fetchTrashed(); }, []);

  const restoreUser = async (id) => {
    setRestoringId(id);
    try {
      await api.put(`/admin/user/${id}/restore`);
      setUsers(prev => prev.filter(u => u._id !== id));
    } catch (e) { console.error(e); alert("Failed to restore"); }
    finally { setRestoringId(null); }
  };

  const permanentDelete = async (id) => {
    setDeletingId(id);
    try {
      await api.delete(`/admin/user/${id}/permanent`);
      setUsers(prev => prev.filter(u => u._id !== id));
    } catch (e) { console.error(e); }
    finally { setDeletingId(null); setConfirmId(null); }
  };

  const filtered = users.filter(u => {
    const mS = u.name?.toLowerCase().includes(search.toLowerCase()) ||
                u.email?.toLowerCase().includes(search.toLowerCase());
    const mR = roleFilter === "all" || u.role === roleFilter;
    return mS && mR;
  });

  const roleStyle = role => {
    if (role==="admin")     return { bg:"#EDE9FE", color:"#7C3AED", border:"#DDD6FE" };
    if (role==="carpenter") return { bg:"#FEF3C7", color:"#D97706", border:"#FDE68A" };
    if (role==="labour")    return { bg:"#E0F2FE", color:"#0369A1", border:"#BAE6FD" };
    return { bg:"#F3F4F6", color:"#6B7280", border:"#E5E7EB" };
  };

  const roleTabs = [
    { key:"all",       label:"All",       count: users.length },
    { key:"carpenter", label:"Carpenter", count: users.filter(u=>u.role==="carpenter").length },
    { key:"labour",    label:"Labour",    count: users.filter(u=>u.role==="labour").length },
    { key:"admin",     label:"Admin",     count: users.filter(u=>u.role==="admin").length },
  ];

  return (
    <>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Plus+Jakarta+Sans:wght@400;500;600;700;800&display=swap');
        @keyframes fadeUp { from{opacity:0;transform:translateY(14px)} to{opacity:1;transform:translateY(0)} }
        @keyframes spin   { to{transform:rotate(360deg)} }
        @keyframes popIn  { from{opacity:0;transform:scale(0.9)} to{opacity:1;transform:scale(1)} }
        *,*::before,*::after { box-sizing:border-box; margin:0; padding:0; }
        body { font-family:'Plus Jakarta Sans',sans-serif; background:#FAF7F4; }
        .sidebar { width:220px; flex-shrink:0; background:#fff; border-right:1.5px solid #E7E5E4; padding:24px 14px; display:flex; flex-direction:column; gap:6px; position:sticky; top:0; height:100vh; overflow-y:auto; }
        .topbar { display:none; }
        .hamburger { display:none; align-items:center; justify-content:center; width:40px; height:40px; border-radius:10px; border:1.5px solid #E7E5E4; background:#fff; cursor:pointer; flex-shrink:0; }
        .sidebar-overlay { display:none; position:fixed; inset:0; background:rgba(0,0,0,.4); z-index:40; }
        .nav-btn { display:flex; align-items:center; gap:9px; width:100%; padding:10px 12px; border-radius:10px; border:none; background:none; font-family:'Plus Jakarta Sans',sans-serif; font-size:14px; font-weight:600; color:#78716C; cursor:pointer; transition:background .15s,color .15s; text-align:left; }
        .nav-btn:hover,.nav-btn.active { background:#FEF3C7; color:#D97706; }
        .nav-btn.danger:hover { background:#FEF2F2; color:#DC2626; }
        .tab-btn { padding:7px 14px; border-radius:20px; border:1.5px solid #E7E5E4; background:#fff; font-family:'Plus Jakarta Sans',sans-serif; font-size:12px; font-weight:700; color:#78716C; cursor:pointer; transition:all .15s; display:flex; align-items:center; gap:5px; }
        .tab-btn:hover { border-color:#D97706; color:#D97706; }
        .tab-btn.active { background:#FEF3C7; border-color:#D97706; color:#92400E; }
        .search-input { width:100%; padding:11px 16px 11px 40px; background:#fff; border:1.5px solid #E7E5E4; border-radius:12px; font-family:'Plus Jakarta Sans',sans-serif; font-size:14px; color:#1C1917; outline:none; transition:border-color .2s; }
        .search-input:focus { border-color:#D97706; box-shadow:0 0 0 3px rgba(217,119,6,.1); }
        .search-input::placeholder { color:#A8A29E; }
        .user-row { transition:background .15s; }
        .user-row:hover { background:#FFFBF7; }
        .modal-overlay { position:fixed; inset:0; background:rgba(0,0,0,.45); z-index:100; display:flex; align-items:center; justify-content:center; padding:16px; }
        .modal-card { background:#fff; border-radius:20px; padding:28px; max-width:380px; width:100%; box-shadow:0 24px 64px rgba(0,0,0,.25); animation:popIn .25s ease; }
        .mobile-cards { display:none; }
        @media (max-width:768px) {
          .sidebar { position:fixed; left:0; top:0; z-index:50; transform:translateX(-100%); transition:transform .28s ease; height:100%; }
          .sidebar.open { transform:translateX(0); }
          .sidebar-overlay.open { display:block; }
          .topbar { display:flex; align-items:center; gap:12px; padding:14px 16px; background:#fff; border-bottom:1.5px solid #E7E5E4; position:sticky; top:0; z-index:30; }
          .hamburger { display:flex; }
          .main-wrap { flex-direction:column !important; }
          .main-content { padding:16px !important; }
          .desktop-table { display:none !important; }
          .mobile-cards { display:block; }
        }
        @media (min-width:769px) and (max-width:1100px) { .sidebar { width:190px; } }
      `}</style>

      {/* Permanent delete confirm modal */}
      {confirmId && (
        <div className="modal-overlay" onClick={() => setConfirmId(null)}>
          <div className="modal-card" onClick={e => e.stopPropagation()}>
            <div style={{ textAlign:"center", marginBottom:"20px" }}>
              <div style={{ fontSize:"44px", marginBottom:"12px" }}>⚠️</div>
              <h3 style={{ fontSize:"18px", fontWeight:"800", color:"#1C1917", marginBottom:"8px" }}>Delete Permanently?</h3>
              <p style={{ fontSize:"14px", color:"#78716C", lineHeight:"1.6" }}>
                This <strong>cannot be undone</strong>. All data for this user will be permanently erased.
              </p>
            </div>
            <div style={{ display:"flex", gap:"10px" }}>
              <button onClick={() => setConfirmId(null)}
                style={{ flex:1, padding:"12px", borderRadius:"12px", border:"1.5px solid #E7E5E4", background:"#fff", fontFamily:"'Plus Jakarta Sans',sans-serif", fontSize:"14px", fontWeight:"700", color:"#78716C", cursor:"pointer" }}>
                Cancel
              </button>
              <button onClick={() => permanentDelete(confirmId)} disabled={!!deletingId}
                style={{ flex:1, padding:"12px", borderRadius:"12px", border:"none", background:"#DC2626", fontFamily:"'Plus Jakarta Sans',sans-serif", fontSize:"14px", fontWeight:"700", color:"#fff", cursor:"pointer", opacity:deletingId?.7:1 }}>
                {deletingId === confirmId ? "Deleting…" : "Delete Forever"}
              </button>
            </div>
          </div>
        </div>
      )}

      <div className="main-wrap" style={{ display:"flex", minHeight:"100vh", fontFamily:"'Plus Jakarta Sans',sans-serif", background:"#FAF7F4" }}>
        <div className={`sidebar-overlay ${sidebarOpen?"open":""}`} onClick={() => setSidebarOpen(false)} />

        {/* SIDEBAR */}
        <aside className={`sidebar ${sidebarOpen?"open":""}`}>
          <div style={{ display:"flex", alignItems:"center", gap:"10px", marginBottom:"28px", padding:"0 4px" }}>
            <div style={{ width:"36px", height:"36px", background:"linear-gradient(135deg,#92400E,#D97706)", borderRadius:"10px", display:"flex", alignItems:"center", justifyContent:"center", flexShrink:0 }}>
              <span style={{ fontSize:"18px" }}>🪚</span>
            </div>
            <div>
              <p style={{ fontWeight:"800", fontSize:"15px", color:"#1C1917" }}>Craftigo</p>
              <p style={{ fontSize:"11px", color:"#A8A29E", fontWeight:"500" }}>Admin Panel</p>
            </div>
          </div>
          <p style={{ fontSize:"11px", fontWeight:"700", color:"#C4B5A4", letterSpacing:"0.7px", textTransform:"uppercase", padding:"0 6px", marginBottom:"6px" }}>Menu</p>
          {navItems.map(n => (
            <button key={n.label} className={`nav-btn ${n.active?"active":""}`}
              onClick={() => { navigate(n.path); setSidebarOpen(false); }}>
              {n.emoji} {n.label}
            </button>
          ))}
          <div style={{ flex:1 }} />
          <div style={{ padding:"12px", background:"#FEF3C7", borderRadius:"12px", border:"1px solid #FDE68A", marginBottom:"10px" }}>
            <p style={{ fontSize:"12px", fontWeight:"700", color:"#92400E" }}>🛡️ Admin Access</p>
            <p style={{ fontSize:"11px", color:"#B45309", marginTop:"2px" }}>Full permissions</p>
          </div>
          <button className="nav-btn danger" onClick={() => { localStorage.clear(); navigate("/login"); }}>🚪 Logout</button>
        </aside>

        <div style={{ flex:1, display:"flex", flexDirection:"column", minWidth:0 }}>
          <div className="topbar">
            <button className="hamburger" onClick={() => setSidebarOpen(true)}>
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
                <line x1="3" y1="6" x2="21" y2="6" stroke="#44403C" strokeWidth="2" strokeLinecap="round"/>
                <line x1="3" y1="12" x2="21" y2="12" stroke="#44403C" strokeWidth="2" strokeLinecap="round"/>
                <line x1="3" y1="18" x2="21" y2="18" stroke="#44403C" strokeWidth="2" strokeLinecap="round"/>
              </svg>
            </button>
            <span style={{ fontWeight:"800", fontSize:"16px", color:"#1C1917" }}>🗑️ Trash</span>
          </div>

          <main className="main-content" style={{ padding:"28px 28px", flex:1, overflowY:"auto" }}>

            {/* Back */}
            <div style={{ marginBottom:"20px", animation:"fadeUp .3s ease both" }}>
              <button onClick={() => navigate("/admin/users")}
                style={{ display:"inline-flex", alignItems:"center", gap:"6px", padding:"7px 14px", background:"#fff", border:"1.5px solid #E7E5E4", borderRadius:"10px", fontFamily:"'Plus Jakarta Sans',sans-serif", fontSize:"13px", fontWeight:"600", color:"#78716C", cursor:"pointer" }}>
                ← Back to Users
              </button>
            </div>

            {/* Header */}
            <div style={{ display:"flex", alignItems:"center", justifyContent:"space-between", marginBottom:"16px", animation:"fadeUp .35s .05s ease both" }}>
              <div>
                <h1 style={{ fontSize:"24px", fontWeight:"800", color:"#1C1917", letterSpacing:"-0.5px" }}>Trash</h1>
                <p style={{ fontSize:"13px", color:"#A8A29E", marginTop:"3px" }}>
                  {loading ? "Loading…" : `${filtered.length} deleted users`}
                </p>
              </div>
              <button onClick={fetchTrashed}
                style={{ padding:"10px 14px", background:"#fff", border:"1.5px solid #E7E5E4", borderRadius:"12px", fontFamily:"'Plus Jakarta Sans',sans-serif", fontSize:"13px", fontWeight:"700", color:"#44403C", cursor:"pointer" }}>
                🔄 Refresh
              </button>
            </div>

            {/* Info banner */}
            <div style={{ background:"#FEF3C7", border:"1.5px solid #FDE68A", borderRadius:"12px", padding:"12px 16px", marginBottom:"16px", display:"flex", alignItems:"center", gap:"10px", animation:"fadeUp .4s .08s ease both" }}>
              <span style={{ fontSize:"18px" }}>ℹ️</span>
              <p style={{ fontSize:"13px", color:"#92400E", fontWeight:"600" }}>
                Users here were soft deleted. Restore to make them active again, or permanently delete to erase all data.
              </p>
            </div>

            {/* Search + role tabs */}
            <div style={{ background:"#fff", border:"1.5px solid #E7E5E4", borderRadius:"16px", padding:"16px", marginBottom:"16px", animation:"fadeUp .4s .1s ease both" }}>
              <div style={{ position:"relative", marginBottom:"14px" }}>
                <span style={{ position:"absolute", left:"13px", top:"50%", transform:"translateY(-50%)", pointerEvents:"none" }}>
                  <svg width="15" height="15" viewBox="0 0 24 24" fill="none">
                    <circle cx="11" cy="11" r="8" stroke="#A8A29E" strokeWidth="2"/>
                    <path d="m21 21-4.35-4.35" stroke="#A8A29E" strokeWidth="2" strokeLinecap="round"/>
                  </svg>
                </span>
                <input className="search-input" type="text" placeholder="Search deleted users…" value={search} onChange={e => setSearch(e.target.value)} />
              </div>
              <div style={{ display:"flex", gap:"8px", flexWrap:"wrap" }}>
                {roleTabs.map(t => (
                  <button key={t.key} className={`tab-btn ${roleFilter===t.key?"active":""}`} onClick={() => setRoleFilter(t.key)}>
                    {t.label}
                    <span style={{ fontSize:"11px", fontWeight:"800", background:roleFilter===t.key?"#D97706":"#F3F4F6", color:roleFilter===t.key?"#fff":"#6B7280", borderRadius:"20px", padding:"1px 7px" }}>{t.count}</span>
                  </button>
                ))}
              </div>
            </div>

            {/* DESKTOP TABLE */}
            <div className="desktop-table" style={{ background:"#fff", border:"1.5px solid #E7E5E4", borderRadius:"16px", overflow:"hidden", animation:"fadeUp .4s .12s ease both" }}>
              <div style={{ display:"grid", gridTemplateColumns:"2fr 2.2fr 1fr 1.2fr 1.6fr", padding:"12px 20px", background:"#FAF7F4", borderBottom:"1.5px solid #E7E5E4" }}>
                {["Name","Email","Role","Deleted On","Actions"].map(h => (
                  <span key={h} style={{ fontSize:"11px", fontWeight:"700", color:"#A8A29E", letterSpacing:"0.6px", textTransform:"uppercase" }}>{h}</span>
                ))}
              </div>

              {loading ? (
                <div style={{ padding:"52px", textAlign:"center" }}>
                  <div style={{ width:"32px", height:"32px", border:"3px solid #FDE68A", borderTop:"3px solid #D97706", borderRadius:"50%", animation:"spin .7s linear infinite", margin:"0 auto 12px" }} />
                  <p style={{ color:"#A8A29E", fontSize:"14px" }}>Loading…</p>
                </div>
              ) : filtered.length === 0 ? (
                <div style={{ padding:"60px", textAlign:"center" }}>
                  <p style={{ fontSize:"44px", marginBottom:"12px" }}>🗑️</p>
                  <p style={{ color:"#78716C", fontWeight:"700", fontSize:"16px" }}>Trash is empty</p>
                  <p style={{ color:"#A8A29E", fontSize:"13px", marginTop:"4px" }}>No deleted users found</p>
                </div>
              ) : (
                filtered.map((u, i) => {
                  const rs = roleStyle(u.role);
                  const deletedOn = u.deletedAt
                    ? new Date(u.deletedAt).toLocaleDateString("en-IN",{day:"numeric",month:"short",year:"numeric"})
                    : "—";
                  return (
                    <div key={u._id} className="user-row"
                      style={{ display:"grid", gridTemplateColumns:"2fr 2.2fr 1fr 1.2fr 1.6fr", padding:"13px 20px", borderBottom: i<filtered.length-1?"1px solid #F5F5F4":"none", alignItems:"center", opacity:0.75 }}>

                      {/* Name */}
                      <div style={{ display:"flex", alignItems:"center", gap:"10px" }}>
                        <div style={{ width:"34px", height:"34px", borderRadius:"50%", background:"#F5F5F4", border:"1.5px solid #E7E5E4", display:"flex", alignItems:"center", justifyContent:"center", fontSize:"13px", fontWeight:"800", color:"#A8A29E", flexShrink:0 }}>
                          {u.name?.charAt(0).toUpperCase()}
                        </div>
                        <div>
                          <p style={{ fontSize:"14px", fontWeight:"600", color:"#78716C" }}>{u.name}</p>
                          <span style={{ fontSize:"10px", fontWeight:"700", background:"#FEF2F2", border:"1px solid #FECACA", color:"#DC2626", borderRadius:"20px", padding:"1px 6px" }}>Deleted</span>
                        </div>
                      </div>

                      <span style={{ fontSize:"13px", color:"#A8A29E", overflow:"hidden", textOverflow:"ellipsis", whiteSpace:"nowrap" }}>{u.email}</span>

                      <span style={{ display:"inline-flex", padding:"3px 9px", borderRadius:"20px", background:rs.bg, border:`1px solid ${rs.border}`, color:rs.color, fontSize:"11px", fontWeight:"700", width:"fit-content", textTransform:"capitalize" }}>
                        {u.role}
                      </span>

                      <span style={{ fontSize:"12px", color:"#A8A29E", fontWeight:"500" }}>{deletedOn}</span>

                      {/* Actions */}
                      <div style={{ display:"flex", gap:"6px" }}>
                        <button onClick={() => restoreUser(u._id)} disabled={restoringId===u._id}
                          style={{ padding:"6px 11px", borderRadius:"8px", border:"1.5px solid #A7F3D0", background:"#D1FAE5", fontFamily:"'Plus Jakarta Sans',sans-serif", fontSize:"11px", fontWeight:"700", color:"#059669", cursor:"pointer", opacity:restoringId===u._id?.6:1, transition:"all .15s" }}
                          onMouseEnter={e=>{e.currentTarget.style.background="#059669";e.currentTarget.style.color="#fff";}}
                          onMouseLeave={e=>{e.currentTarget.style.background="#D1FAE5";e.currentTarget.style.color="#059669";}}>
                          {restoringId===u._id ? "…" : "♻️ Restore"}
                        </button>
                        <button onClick={() => setConfirmId(u._id)} disabled={!!deletingId}
                          style={{ padding:"6px 11px", borderRadius:"8px", border:"1.5px solid #FECACA", background:"#FEF2F2", fontFamily:"'Plus Jakarta Sans',sans-serif", fontSize:"11px", fontWeight:"700", color:"#DC2626", cursor:"pointer", transition:"all .15s" }}
                          onMouseEnter={e=>{e.currentTarget.style.background="#DC2626";e.currentTarget.style.color="#fff";}}
                          onMouseLeave={e=>{e.currentTarget.style.background="#FEF2F2";e.currentTarget.style.color="#DC2626";}}>
                          🗑 Delete Forever
                        </button>
                      </div>
                    </div>
                  );
                })
              )}
            </div>

            {/* MOBILE CARDS */}
            <div className="mobile-cards">
              {loading ? (
                <div style={{ padding:"48px", textAlign:"center" }}>
                  <div style={{ width:"32px", height:"32px", border:"3px solid #FDE68A", borderTop:"3px solid #D97706", borderRadius:"50%", animation:"spin .7s linear infinite", margin:"0 auto" }} />
                </div>
              ) : filtered.length === 0 ? (
                <div style={{ padding:"52px", textAlign:"center" }}>
                  <p style={{ fontSize:"40px", marginBottom:"10px" }}>🗑️</p>
                  <p style={{ color:"#78716C", fontWeight:"700", fontSize:"15px" }}>Trash is empty</p>
                </div>
              ) : (
                <div style={{ display:"flex", flexDirection:"column", gap:"10px" }}>
                  {filtered.map(u => {
                    const rs = roleStyle(u.role);
                    const deletedOn = u.deletedAt
                      ? new Date(u.deletedAt).toLocaleDateString("en-IN",{day:"numeric",month:"short",year:"numeric"})
                      : "—";
                    return (
                      <div key={u._id} style={{ background:"#fff", border:"1.5px solid #E7E5E4", borderRadius:"14px", padding:"16px", display:"flex", alignItems:"center", gap:"12px", opacity:0.8 }}>
                        <div style={{ width:"44px", height:"44px", borderRadius:"50%", background:"#F5F5F4", border:"1.5px solid #E7E5E4", display:"flex", alignItems:"center", justifyContent:"center", fontSize:"18px", fontWeight:"800", color:"#A8A29E", flexShrink:0 }}>
                          {u.name?.charAt(0).toUpperCase()}
                        </div>
                        <div style={{ flex:1, minWidth:0 }}>
                          <p style={{ fontSize:"14px", fontWeight:"700", color:"#78716C", overflow:"hidden", textOverflow:"ellipsis", whiteSpace:"nowrap" }}>{u.name}</p>
                          <p style={{ fontSize:"12px", color:"#A8A29E", overflow:"hidden", textOverflow:"ellipsis", whiteSpace:"nowrap" }}>{u.email}</p>
                          <div style={{ display:"flex", gap:"5px", marginTop:"4px", flexWrap:"wrap" }}>
                            <span style={{ padding:"2px 8px", borderRadius:"20px", background:rs.bg, border:`1px solid ${rs.border}`, color:rs.color, fontSize:"10px", fontWeight:"700", textTransform:"capitalize" }}>{u.role}</span>
                            <span style={{ padding:"2px 8px", borderRadius:"20px", background:"#FEF2F2", border:"1px solid #FECACA", color:"#DC2626", fontSize:"10px", fontWeight:"700" }}>Deleted {deletedOn}</span>
                          </div>
                        </div>
                        <div style={{ display:"flex", flexDirection:"column", gap:"5px", flexShrink:0 }}>
                          <button onClick={() => restoreUser(u._id)} disabled={restoringId===u._id}
                            style={{ padding:"6px 9px", borderRadius:"8px", border:"1.5px solid #A7F3D0", background:"#D1FAE5", fontSize:"12px", fontWeight:"700", color:"#059669", cursor:"pointer" }}>
                            {restoringId===u._id?"…":"♻️"}
                          </button>
                          <button onClick={() => setConfirmId(u._id)}
                            style={{ padding:"6px 9px", borderRadius:"8px", border:"1.5px solid #FECACA", background:"#FEF2F2", fontSize:"12px", fontWeight:"700", color:"#DC2626", cursor:"pointer" }}>
                            🗑
                          </button>
                        </div>
                      </div>
                    );
                  })}
                </div>
              )}
            </div>

          </main>
        </div>
      </div>
    </>
  );
}